export default "__VITE_ASSET__64f87860__"